import { render } from "./ButtonsCard.vue?vue&type=template&id=2f610091&scoped=true"
import script from "./ButtonsCard.vue?vue&type=script&lang=js"
export * from "./ButtonsCard.vue?vue&type=script&lang=js"

import "./ButtonsCard.vue?vue&type=style&index=0&id=2f610091&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f610091"]])

export default __exports__